/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BreezePersonMDSMemberRequest } from '../models/BreezePersonMDSMemberRequest'
import type { MdsMemberIdsRequest } from '../models/MdsMemberIdsRequest'
import type { MdsMemberMergeRequest } from '../models/MdsMemberMergeRequest'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsMdsUtilitiesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Assigns an MDS Member ID to an existing Breeze Person.
     * Will overwrite any existing MDS Member ID on the Breeze Person.
     * @returns void
     * @throws ApiError
     */
    public assignMdsMemberIdToExistingPerson({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: BreezePersonMDSMemberRequest
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/mds-utilities/assign-mds-to-breeze-person',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Deletes MDS Members by their IDs.
     * Does not affect Breeze People.
     * @returns void
     * @throws ApiError
     */
    public deleteMdsMembers({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: MdsMemberIdsRequest
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/organizations/{organization}/mds-utilities/delete-mds-members',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * This is for merging duplicate MDS members that share a Breeze ID in MDS
     * This is for merging duplicate MDS members that share a Breeze ID in MDS
     * @returns void
     * @throws ApiError
     */
    public mergeMdsMembers({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: MdsMemberMergeRequest
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/mds-utilities/merge-mds-members',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * This restores previously deleted MDS Members.
     * Does not affect Breeze People.
     * @returns void
     * @throws ApiError
     */
    public restoreMdsMembers({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: MdsMemberIdsRequest
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/mds-utilities/restore-mds-members',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
